/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */

import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";
import PropTypes from "prop-types";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const UploadVolumeChart = ({ chartData }) => {
  const handleViewMore = () => {
    window.Ext.getCmp("sideBar").selectNodeById("sidebar-nav-reports");
  };
  const options = {
    scales: {
      x: {
        width: 0,
        offset: true,
      },
      y: {
        beginAtZero: true,
      },
    },
    maintainAspectRatio: false,
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
    },
  };
  if (chartData.length === 0) {
    return (
      <div className="upload_volume_chart" data-testid="upload-volume-chart">
        <span className="upload_volume_chart__title">Recent Uploads</span>
        <div className="upload_volume_chart__content">No data</div>
      </div>
    );
  }
  // https://react-chartjs-2.js.org/components/line
  // https://www.chartjs.org/docs/latest/charts/line.html
  const data = {
    labels: chartData.map(
      (r) => r[0].substring(0, 1).toUpperCase() + r[0].substring(1)
    ),
    datasets: [
      {
        label: "Files uploaded",
        data: chartData.map((r) => r[1]),
        fill: false,
        borderColor: "rgb(75, 192, 192)",
        tension: 0.1,
      },
    ],
  };
  return (
    <div className="upload_volume_chart" data-testid="upload-volume-chart">
      <span className="upload_volume_chart__title">Recent Uploads</span>
      <div className="upload_volume_chart__content">
        <div className="upload_volume_chart__content__inner">
          <div className="upload_volume_chart__content__inner__chart">
            <span className="upload_volume_chart__content__inner__chart__legend">
              Upload Volume
            </span>
            <Line options={options} data={data} />
          </div>
        </div>
        <span
          className="upload_volume_chart__content__link"
          onClick={handleViewMore}
        >
          View More
        </span>
      </div>
    </div>
  );
};

export default UploadVolumeChart;

UploadVolumeChart.propTypes = {
  chartData: PropTypes.oneOfType([PropTypes.array]).isRequired,
};
